<template>
  <FormInput
    type="number"
    :label="label"
    :fieldValue="discountValue"
    :readonly="!$validate.DataValid(discountType)"
    :prefix="discountType === 'fix_amount' ? '$' : ''"
    :suffix="discountType === 'percentage' ? '%' : ''"
    :disabled="disabled"
    :required="required"
    :dispatchUpdateOnChange="dispatchUpdateOnChange"
    :isIntegerOnly="discountType === 'percentage' || isAppMode(['T01'])"
    isStrictFloat
    :customRules="[v => !$validate.DataValid(v) || parseFloat(v) > 0 || $t('message.valueShouldNotBeZero')]"
    @input-value="$emit('update:discountValue', $event)"
  />
</template>

<script>
import FormInput from './FormInput.vue'
export default {
  name: 'FormDiscount',
  components: {
    FormInput,
  },
  props: {
    discountValue: {
      type: String | Number,
      default: '',
      required: true,
    },
    discountType: {
      type: String | null,
      default: '',
      required: true,
    },
    price: {
      type: String | Number,
      default: -1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    dispatchUpdateOnChange: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    label() {
      let s = this.$t('discount')

      if (this.$validate.DataValid(this.discountType) && this.$validate.regexFloating(this.discountValue)) {
        if (this.discountType === 'percentage') {
          s += ' ('
          if (this.$i18n.locale === 'en') {
            s += `${this.discountValue}% off`
          } else {
            const off = 100 - parseFloat(this.discountValue)
            s += `${off <= 0 ? 10 : parseFloat((off * 0.1).toFixed(1))}折`
          }
          s += ')'
        } else if (this.discountType === 'fix_amount') {
          let discount = parseFloat(this.discountValue)
          if (
            this.$validate.regexFloating(this.price) &&
            parseFloat(this.price) >= 0 &&
            discount > parseFloat(this.price)
          ) {
            discount = parseFloat(this.price)
          }
          s += ` (-$ ${this.$formatter.formatMoney(discount)})`
        }
      }

      return s
    },
  },
}
</script>
